import { render, staticRenderFns } from "./BslApiComponent.vue?vue&type=template&id=7a7aa907&scoped=true&"
import script from "./BslApiComponent.vue?vue&type=script&lang=js&"
export * from "./BslApiComponent.vue?vue&type=script&lang=js&"
import style0 from "./BslApiComponent.vue?vue&type=style&index=0&id=7a7aa907&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7aa907",
  null
  
)

export default component.exports